import { createAsyncThunk } from '@reduxjs/toolkit';
import { allChannelsFetched } from './allChannelsFetched';

/**
 * Fetches all channels (joined and unjoined if param is set) of the current user
 */

const fetchCurrentUserChannels = createAsyncThunk(
  'channels/fetchCurrentUserChannels',
  /** @param {{ specificChannelId?: string, channelTypes?: string[], onlyUnjoinedChannels?: boolean }} [options] */
  async ({ specificChannelId, channelTypes, onlyUnjoinedChannels } = {}, { dispatch, extra: { gccApiClient } }) => {
    const response = await gccApiClient.getCurrentUserChannels({
      specificChannelId,
      channelTypes,
      onlyUnjoinedChannels,
    });

    dispatch(
      allChannelsFetched({
        ...response,
        replaceChannelTypes: channelTypes,
      }),
    );
    return response;
  },
);

export default fetchCurrentUserChannels;
